export const saasBlockFields = [
  { id: "email", name: "email" },
  { id: "first_name", name: "first_name" },
  { id: "ip", name: "ip" },
  { id: "last_name", name: "last_name" },
];
